import { PaidCustodyProps } from './types';

export const getPaidCustodyHeadItems = (item: PaidCustodyProps['item']) => [
  {
    label: 'Custódia remunerada-Aluguel turbo',
    value: item.paidCustodyInfo.paidCustodyAvailable ? 'Contratado' : 'Não contratado',
  },
  {
    label: 'Quantidade doado',
    value: item.paidCustodyInfo.donatedQuantity,
  },
  {
    label: 'Quantidade tomado',
    value: item.paidCustodyInfo.receivedQuantity,
  },
];
// <PaidCustodyHeadItem
//   isMobile
//   label="Custódia remunerada-Aluguel turbo"
//   value={item.paidCustodyInfo.paidCustodyAvailable ? 'Contratado' : 'Não contratado'}
// />
// <PaidCustodyHeadItem
//   isMobile
//   label="Quantidade doado"
//   value={item.paidCustodyInfo.donatedQuantity}
// />
// <PaidCustodyHeadItem
//   isMobile
//   label="Aluguel doado"
//   value={item.paidCustodyInfo.donatedRent}
//   tooltip="Este valor corresponde ao financeiro da posição de ações emprestadas no contrato de aluguel."
// />
// <PaidCustodyHeadItem
//   isMobile
//   label="Quantidade tomado"
//   value={item.paidCustodyInfo.receivedQuantity}
// />
// <PaidCustodyHeadItem
//   isMobile
//   label="Aluguel tomado"
//   value={item.paidCustodyInfo.receivedRent}
//   tooltip="Este valor corresponde ao financeiro da posição de ações vendidas no contrato de aluguel."
// />
